import React from "react";

export default function Title({ text, image, alt = "", className = "" }) {
    return (
        <h2 className={`text-3xl mb-2 md:text-4xl lg:text-5xl md:mb-4 h-fit flex items-end gap-6 ${className}`}>
            {image && (
                <img src={image} alt={alt || text} className="w-[40px] h-[40px] md:w-[50px] md:h-[50px]" />
            )}
            {text}
        </h2>
    );
} 